import { QueryBuilder } from '@cxc/core/builders';
import { OUT_OF_STANDARD_CURRENCY } from '@cxc/core/enums';
import { withCache } from '@ngneat/cashew';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';

import { API } from '@models/API/index';

import { platformAPI } from '@services/API/endpoints';

@Injectable({ providedIn: 'root' })
export class Overview {
  constructor(private http: HttpClient) {}

  get(
    lenderId: string,
    cutOffDate: string,
    loaderOptIn: boolean | string = true
  ) {
    const query = new QueryBuilder();
    query.equals('cutoff_date', cutOffDate);

    return this.http.get<API.Trusts.Lender.Overview.Response>(
      platformAPI.trusts(lenderId).lender.overview(query),
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
          'Auth-Opt-In': 'true',
        }),
        context: withCache({
          ttl: environment.CACHE_LIFETIME,
        }),
      }
    );
  }

  getResume(
    lenderId: string,
    reportedAt: string,
    currency: OUT_OF_STANDARD_CURRENCY,
    loaderOptIn: boolean | string = true
  ) {
    const params = new HttpParams({
      fromObject: {
        reported_at: reportedAt,
        currency: currency,
      },
    });

    return this.http.get<API.Trusts.Lender.Overview.Resume.Response>(
      platformAPI.trusts(lenderId).lender.overviewResume,
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
          'Auth-Opt-In': 'true',
        }),
        params: params,
        context: withCache({
          ttl: environment.CACHE_LIFETIME,
        }),
      }
    );
  }
}
